import {AdditionalEvent} from '@/api/dto/care-journey';
import DisplayHelpers from '@/helpers/display_helpers';

// triggeredBy is date-only; the setting word is omitted when eventSetting is null.
export function buildTriggeredByText(event: AdditionalEvent): string {
  const date = event.eventDateTime
    ? DisplayHelpers.formatDate(event.eventDateTime)
    : DisplayHelpers.formatDate(event.createdAt);
  return `Triggered by: ${event.eventSetting ? `${event.eventSetting} ` : ''}event on ${date}`;
}
